import { GENERATE_CSV_FORM_SUBMITTED } from './reports.types';

export const requestCSVGeneration = payload => ({
  type: GENERATE_CSV_FORM_SUBMITTED,
  payload,
});
